
import { Link } from 'react-router-dom';

export default function ProjectsCTA() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-3xl overflow-hidden">
          <div className="absolute inset-0 w-full h-full">
            <img
              src="https://public.readdy.ai/ai/img_res/d341433da6332cf12909ee2b918365c3.jpg"
              alt="Automatización robótica avanzada"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80"></div>
          </div>

          <div className="relative z-10 py-16 md:py-20 px-8 md:px-16 text-center">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
              ¿Tienes un Proyecto en Mente?
            </h2>
            <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto mb-8">
              Cuéntanos tu idea y nuestro equipo de ingenieros diseñará la solución robótica perfecta para tu industria. Consultoría inicial gratuita.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/"
                onClick={() => setTimeout(() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100)}
                className="px-8 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white text-sm font-semibold rounded-full hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
              >
                Solicitar Consultoría Gratuita →
              </Link>
              <Link
                to="/"
                className="px-8 py-4 border-2 border-white/40 text-white text-sm font-semibold rounded-full hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
              >
                Volver al Inicio
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
